import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';

export default function LoginPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState<'login' | 'register' | 'reset'>('login');
  const [showPass, setShowPass] = useState(false);
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [regData, setRegData] = useState({ company: '', name: '', email: '', phone: '', password: '' });
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate('/dashboard');
    }, 1200);
  };

  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTab('login');
    }, 1200);
  };

  const handleReset = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setResetSent(true);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-firmai-dark flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="w-full max-w-4xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left - Brand */}
            <div className="hidden lg:block">
              <div className="relative">
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,217,163,0.2) 1px, transparent 0)', backgroundSize: '30px 30px' }} />
                </div>
                <div className="relative z-10 space-y-8 p-4">
                  <div>
                    <img src="https://public.readdy.ai/ai/img_res/b5b3c1b8-bbd4-4161-b813-5c9d75b1cee8.png" alt="Firmai" className="h-10 w-auto mb-4" />
                    <h1 className="text-white font-bold text-2xl md:text-3xl leading-tight mb-3">
                      工业双碳数字化<br />智能管理平台
                    </h1>
                    <p className="text-firmai-text text-sm leading-relaxed">
                      登录后访问工信部碳排申报数据、CCER/CBAM合规填报、工业AI监控等全部功能
                    </p>
                  </div>

                  <div className="space-y-3">
                    {[
                      { icon: 'ri-government-line', text: '工信部碳排放申报全流程管理' },
                      { icon: 'ri-robot-2-line', text: '工业AI实时监控与预测分析' },
                      { icon: 'ri-global-line', text: 'CCER/CBAM合规数据直连提交' },
                      { icon: 'ri-shield-check-line', text: '区块链存证，数据安全可信' },
                      { icon: 'ri-bar-chart-2-line', text: '数字化能碳管理中心12项功能' },
                    ].map((item) => (
                      <div key={item.text} className="flex items-center gap-3">
                        <span className="w-7 h-7 flex items-center justify-center bg-firmai-green/15 rounded-lg text-firmai-green shrink-0">
                          <i className={item.icon} />
                        </span>
                        <span className="text-firmai-text text-sm">{item.text}</span>
                      </div>
                    ))}
                  </div>

                  <div className="bg-firmai-card border border-firmai-border rounded-xl p-4">
                    <div className="grid grid-cols-3 gap-3 text-center">
                      {[{ v: '500+', l: '工业客户' }, { v: '12项', l: '功能覆盖' }, { v: '99.5%', l: '申报准确率' }].map((s) => (
                        <div key={s.l}>
                          <div className="text-firmai-green font-bold text-lg">{s.v}</div>
                          <div className="text-firmai-muted text-xs mt-0.5">{s.l}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Form */}
            <div className="bg-firmai-card border border-firmai-border rounded-2xl p-6 md:p-8">
              {/* Tabs */}
              {tab !== 'reset' && (
                <div className="flex p-1 bg-firmai-dark border border-firmai-border rounded-lg mb-6">
                  {(['login', 'register'] as const).map((t) => (
                    <button
                      key={t}
                      onClick={() => setTab(t)}
                      className={`flex-1 py-2 text-sm font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap ${
                        tab === t ? 'bg-firmai-green text-firmai-dark' : 'text-firmai-text hover:text-white'
                      }`}
                    >
                      {t === 'login' ? '企业用户登录' : '注册新账号'}
                    </button>
                  ))}
                </div>
              )}

              {/* Login Form */}
              {tab === 'login' && (
                <form onSubmit={handleLogin} className="space-y-4">
                  <div>
                    <label className="block text-firmai-muted text-xs mb-1.5">邮箱 / 手机号</label>
                    <input
                      type="text"
                      value={loginData.email}
                      onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                      required
                      placeholder="请输入邮箱或手机号"
                      className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-4 py-3 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-firmai-muted text-xs mb-1.5">密码</label>
                    <div className="relative">
                      <input
                        type={showPass ? 'text' : 'password'}
                        value={loginData.password}
                        onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                        required
                        placeholder="请输入密码"
                        className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-4 py-3 pr-10 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPass(!showPass)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-firmai-muted hover:text-firmai-text cursor-pointer"
                      >
                        <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'} />
                      </button>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" className="w-3.5 h-3.5 accent-firmai-green" />
                      <span className="text-firmai-muted text-xs">记住我</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setTab('reset')}
                      className="text-firmai-green text-xs hover:underline cursor-pointer"
                    >
                      忘记密码？
                    </button>
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3 bg-firmai-green text-firmai-dark font-semibold rounded-lg hover:bg-firmai-green/90 transition-all duration-200 cursor-pointer disabled:opacity-60 whitespace-nowrap"
                  >
                    {loading ? '登录中...' : '立即登录'}
                  </button>
                  <div className="text-center text-xs text-firmai-muted">
                    还没有账号？
                    <button type="button" onClick={() => setTab('register')} className="text-firmai-green ml-1 cursor-pointer hover:underline">
                      免费注册
                    </button>
                  </div>
                </form>
              )}

              {/* Register Form */}
              {tab === 'register' && (
                <form onSubmit={handleRegister} className="space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-firmai-muted text-xs mb-1.5">企业名称 <span className="text-red-400">*</span></label>
                      <input
                        type="text"
                        value={regData.company}
                        onChange={(e) => setRegData({ ...regData, company: e.target.value })}
                        required
                        placeholder="公司全称"
                        className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-firmai-muted text-xs mb-1.5">联系人 <span className="text-red-400">*</span></label>
                      <input
                        type="text"
                        value={regData.name}
                        onChange={(e) => setRegData({ ...regData, name: e.target.value })}
                        required
                        placeholder="姓名"
                        className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-firmai-muted text-xs mb-1.5">邮箱 <span className="text-red-400">*</span></label>
                    <input
                      type="email"
                      value={regData.email}
                      onChange={(e) => setRegData({ ...regData, email: e.target.value })}
                      required
                      placeholder="企业邮箱"
                      className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-firmai-muted text-xs mb-1.5">手机号 <span className="text-red-400">*</span></label>
                    <input
                      type="tel"
                      value={regData.phone}
                      onChange={(e) => setRegData({ ...regData, phone: e.target.value })}
                      required
                      placeholder="手机号码"
                      className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-firmai-muted text-xs mb-1.5">设置密码 <span className="text-red-400">*</span></label>
                    <input
                      type="password"
                      value={regData.password}
                      onChange={(e) => setRegData({ ...regData, password: e.target.value })}
                      required
                      placeholder="至少8位，包含字母和数字"
                      className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3 bg-firmai-green text-firmai-dark font-semibold rounded-lg hover:bg-firmai-green/90 transition-all duration-200 cursor-pointer disabled:opacity-60 whitespace-nowrap"
                  >
                    {loading ? '注册中...' : '立即注册'}
                  </button>
                  <p className="text-firmai-muted text-xs text-center">
                    注册即同意
                    <span className="text-firmai-green mx-1 cursor-pointer hover:underline">服务条款</span>
                    和
                    <span className="text-firmai-green mx-1 cursor-pointer hover:underline">隐私政策</span>
                  </p>
                </form>
              )}

              {/* Reset Password */}
              {tab === 'reset' && (
                <div>
                  <button
                    onClick={() => { setTab('login'); setResetSent(false); }}
                    className="flex items-center gap-1 text-firmai-muted text-sm mb-5 cursor-pointer hover:text-firmai-text"
                  >
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-left-line" /></span>
                    返回登录
                  </button>
                  <h2 className="text-white font-bold text-lg mb-1">重置密码</h2>
                  <p className="text-firmai-muted text-sm mb-5">输入注册邮箱，我们将发送重置链接</p>
                  {resetSent ? (
                    <div className="text-center py-8">
                      <span className="w-14 h-14 flex items-center justify-center mx-auto bg-firmai-green/10 rounded-full text-firmai-green mb-3">
                        <i className="ri-mail-send-line text-2xl" />
                      </span>
                      <div className="text-white font-semibold mb-2">重置邮件已发送</div>
                      <p className="text-firmai-muted text-sm">请查收邮件并按照指引完成密码重置</p>
                    </div>
                  ) : (
                    <form onSubmit={handleReset} className="space-y-4">
                      <input
                        type="email"
                        value={resetEmail}
                        onChange={(e) => setResetEmail(e.target.value)}
                        required
                        placeholder="注册邮箱"
                        className="w-full bg-firmai-dark border border-firmai-border rounded-lg px-4 py-3 text-white text-sm placeholder-firmai-muted focus:outline-none focus:border-firmai-green/50 transition-colors"
                      />
                      <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 bg-firmai-green text-firmai-dark font-semibold rounded-lg hover:bg-firmai-green/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
                      >
                        {loading ? '发送中...' : '发送重置链接'}
                      </button>
                    </form>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}